module.exports = __webpack_public_path__ + "static/img/image_solutions_ime_06.75c56d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_ime_06.png
// module id = f3/P
// module chunks = 10